import {Dialog, IconButton} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useBoolState} from "@/hooks";
import {DocumentDialogContent} from "@/components/documents/DialogContent";

export const DocumentsIconButton = () => {
    const [isShow, show, hide] = useBoolState();

    return (
        <>
            <IconButton size="medium" color="primary" onClick={show}>
                <FontAwesomeIcon icon="question-circle" />
            </IconButton>
            <Dialog open={isShow} onClose={hide}>
                <DocumentDialogContent close={hide} />
            </Dialog>
        </>
    );
};
